module.exports = __webpack_public_path__ + "img/22.b6c33c8b.gif";